// @ts-nocheck

import AddCarePlanModal from './AddCarePlanModal'
import AddEmarMedicationModal from './AddEmarMedicationModal'
import AddLogModal from './AddLogModal'
import AddResidentModal from './AddResidentModal'
import AddShiftModal from './AddShiftModal'
import AddTeamMemberModal from './AddTeamMemberModal'
import AddZoneModal from './AddZoneModal'
import CarePlanDocumentModal from './CarePlanDocumentModal'
import CreateRiskAssessment from './CreateRiskAssessment'
import DocumentModal from './DocumentModal'
import EditResidentZoneModal from './EditResidentZoneModal'
import EditShiftModal from './EditShiftModal'
import EditZoneModal from './EditZoneModal'
import EmarDiscontinueMedModal from './EmarDiscontinueMedModal'
import EmarMedicationQuantityModal from './EmarMedicationQuantityModal'
import EmarRoundTimingModal from './EmarRoundTimingModal'
import FamilyPortalSetupModal from './FamilyPortalSetupModal'
import HomeChangedBlockingModal from './HomeChangedBlockingModal'
import InviteFamilyModal from './InviteFamilyModal'
import OnboardEmarModal from './OnboardEmarModal'
import StockLogModal from './StockLogModal'
import SwitchHomeModal from './SwitchHomeModal'
import TaskCreateModal from './TaskCreateModal'
import TaskEditModal from './TaskEditModal'

const MountedModals = ({ router }) => (
  <div>
    <AddCarePlanModal router={router} />
    <AddResidentModal router={router} />
    <SwitchHomeModal router={router} />
    <HomeChangedBlockingModal />
    <AddTeamMemberModal router={router} />
    <AddShiftModal />
    <AddZoneModal />
    <CreateRiskAssessment router={router} />
    <CarePlanDocumentModal />
    <DocumentModal />
    <EditResidentZoneModal />
    <EditShiftModal />
    <EditZoneModal />
    <FamilyPortalSetupModal />
    <TaskEditModal />
    <TaskCreateModal />
    <AddLogModal />
    <InviteFamilyModal />
    <AddEmarMedicationModal router={router} />
    <OnboardEmarModal router={router} />
    <EmarRoundTimingModal />
    <EmarDiscontinueMedModal />
    <EmarMedicationQuantityModal />
    <StockLogModal />
  </div>
)

export default MountedModals
